import { createApiSlice } from "@common";
import { CRUD_EMPLOYEE_DOCUMENTS } from "@routes";

const apiConfig = [
  {
    name: "addEmployeeDocuments",
    method: "post",
    url: CRUD_EMPLOYEE_DOCUMENTS,
    stateKey: "message"
  },
  {
    name: "getEmployeeDocuments",
    method: "get",
    url: CRUD_EMPLOYEE_DOCUMENTS,
    stateKey: "data"
  },
  {
    name: "updateEmployeeDocuments",
    method: "put",
    url: CRUD_EMPLOYEE_DOCUMENTS,
    stateKey: "message"
  },
  {
    name: "deleteEmployeeDocuments",
    method: "delete",
    url: CRUD_EMPLOYEE_DOCUMENTS,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "employeeDocuments",
  apiConfig,
  customReducers
);
const employeeDocumentsSlice = slice;

export default employeeDocumentsSlice.reducer;

export const {
  addEmployeeDocuments,
  getEmployeeDocuments,
  updateEmployeeDocuments,
  deleteEmployeeDocuments
} = thunks;
export const { rowSelect } = actions;
